<template>
  <div class="operation-log">
    <search-form :fields="searchFields" @submit="handleSubmit" :isDownBtn="isDown" :exportFileFun="exportFileFun"/>
    <smart-table
      class="log-table"
      ref="smartTable"
      :border="true"
      :base-url="tableData.baseURL"
      :api-path="tableData.apiPath"
      :defaultParam="tableData.defaultParam"
      :param="param"
      :columns="tableData.columns"
      :row-key="(record, index) => index"
      :scroll="{ y: tableData.scrollY }"
      :isFixed="false"
    >
      <template slot="createTime" slot-scope="text, record">
        <div>{{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
      </template>
      <template slot="optTime" slot-scope="text, record">
        <div>{{moment(record.optTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
      </template>
      <template slot="client" slot-scope="text, record">
        <div>{{record.client === 1 ? 'PC':'Mobile'}}</div>
      </template>
      <template slot="optType" slot-scope="text, record">
        <div v-if="record.optType">{{statusText(record.optType)}}</div>
      </template>
      <template slot="optContext" slot-scope="text, record">
        <div class="ellipsis">
          <tool-tip :record="record"></tool-tip>
        </div>
      </template>
      <a-table
        :slot="tableData.innerColumns && 'expandedRowRender'"
        slot-scope="record"
        size="small"
        :columns="tableData.innerColumns"
        :data-source="record.childrenData ? record.childrenData : []"
        :pagination="false"
        :row-key="(record, index) => index"
      >
      </a-table>
    </smart-table>
  </div>
</template>
<script>
// import { PageView } from '@/layouts'
import SearchForm from '@/components/SearchForm'
import SmartTable from '@/components/SmartTable'
import ToolTip from '@/components/Tips/ToolTip'

import moment from 'moment'
export default {
  name: 'OperationLog',
  components: {
    // PageView,
    SearchForm,
    SmartTable,
    ToolTip
  },
  props: {
    searchFields: {
      type: Array,
      default () {
        return []
      }
    },
    tableData: {
      type: Object,
      default: () => {
        return {
          baseURL: '',
          apiPath: '',
          defaultParam: {},
          columns: []
        }
      }
    },
    doItem: { // 选择的操作类型
      type: Object,
      default: () => {
        return {
          formKey: 'optType',
          options: [
            { value: 1, label: '新增' },
            { value: 2, label: '修改' },
            { value: 3, label: '删除' },
            { value: 4, label: '启用' },
            { value: 5, label: '停用' },
            { value: 6, label: '审核' }
          ],
          placeholder: '选择操作内容'
        }
      }
    },
    isDown: {
      type: Boolean,
      default: false
    },
    exportFileFun: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      form: {},
      param: {}
    }
  },
  created () {
    console.log('dasdas', this.isDown)
  },
  methods: {
    moment,
    fetch () {
      this.$refs.smartTable.fetch()
    },
    handleSubmit (value) {
      const { param } = this
      this.param = {
        ...param,
        ...value,
        page: 1
      }
    },
    contFormat (item) {
      if (item.detail) {
        return `${item.title}：${item.detail}`
      } else {
        return `${item.title}：${item.oldContent} => ${item.newContent}`
      }
    },
    statusText (status = '') {
      if (typeof status === 'string' && status.split(',').length > 0) { // 用于基本信息的操作对象
        const items = (this.searchFields[0]?.options || []).filter(it => {
          return status.split(',').includes(it.value)
        })
        return items.map(plan => plan.label).join(',')
      }
      if (status) {
        const item = (this.searchFields[0]?.options || []).find(it => {
          return status === it.value
        })
        if (item) return item.label
        return ''
      }
    }
  },
  mounted () {
    console.log('dasdas')
    console.log('isDown', this.isDown)
    this.$refs.smartTable.fetch()
  }
}
</script>
<style lang="less">
.log-table {
  /deep/ .smart-table {
    /deep/ .ant-table-pagination.ant-pagination {
      padding-top: 10px;
    }
  }

  /deep/ .opt-detail p{
    margin-bottom: 5px;
  }
  /deep/ .ant-table-tbody > tr > td {
    padding: 9px 8px 8px;
  }
  .ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    word-break: break-all;
  }
}
// .ant-notification-notice-with-icon .ant-notification-notice-description {
//     margin-left: 42px!important;
//   }
.ant-form-inline .ant-form-item {
  margin-right: 10px;
}
  @keyframes rotating{
    from{transform:rotate(0)}
    to{transform:rotate(360deg)}
  }
  .icon-transform {
    animation:rotating 0.5s linear infinite
  }
  .ant-table table {
    font-size: 12px;
  }
</style>
